import { render, staticRenderFns } from "./ficha-turno-1.vue?vue&type=template&id=e4257726"
import script from "./ficha-turno-1.vue?vue&type=script&lang=js"
export * from "./ficha-turno-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports